import {
    FlyoutBadgeType,
    FlyoutSize,
} from './__generated__/AppBarControlQuery.graphql';
import { LaunchTile_m365App } from './__generated__/LaunchTile_m365App.graphql';
import { FlyoutProps } from './Flyout.types';
/**
 * Props for the More Apps flyout button
 */
export interface FlyoutButtonProps extends FlyoutProps {
    /**
     * Determines whether the flyout button can render a dot badge, a numeric badge, neither, or both.
     */
    enabledFlyoutButtonBadgeType?: FlyoutBadgeType;

    /**
     * Accessible, localized description for the flyout button badge
     */
    flyoutButtonBadgeDescription?: string;

    /**
     * Text to display under the flyout button on the AppBar
     */
    text?: string | undefined;

    /**
     * Title for Flyout Button for Accessibility
     */
    title: string;

    /**
     * True if the flyout button should render in the 'selected' state with a filled icon
     */
    selected: boolean;

    /**
     * True if the button should be rendered in wide mode
     */
    wide?: boolean | undefined;

    /**
     * Optional icon to use instead of MoreAppsIcon
     */
    icon?: LaunchTile_m365App['icon'] | undefined;

    /**
     * Selected state icon for the optional icon to use instead of MoreAppsIcon
     */
    selectedIcon?: LaunchTile_m365App['icon'] | undefined;

    /**
     * The flyout size to use.  Defaults to large.
     */
    flyoutSize: FlyoutSize;

    /**
     * This will enable visual refresh styles for the flyout button
     */
    enableVisualRefreshStyles?: boolean | undefined;
}

/**
 * Event names used to close the flyout when fired
 */
export enum EventType {
    RESIZE = 'resize',
    SCROLL = 'scroll',
}
